import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { IoClose } from "react-icons/io5";

const StockInModal = ({
  open,
  onClose,
  stockData = null,
  onSubmit,
  isStockIn = true,
}) => {
  const [quantity, setQuantity] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!quantity || isNaN(quantity) || Number(quantity) <= 0) {
      setError("Please enter a valid quantity greater than 0");
      return;
    }
    setError("");
    onSubmit({
      quantity: Number(quantity),
      description,
    });
    setQuantity("");
    setDescription("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "12px" },
      }}
    >
      <DialogTitle
        className="d-flex justify-content-between align-items-center border-bottom mb-3"
        sx={{ p: 2, pb: 1 }}
      >
        <span className="fw-medium" style={{ fontSize: "1.1rem" }}>
          {isStockIn ? "Stock In" : "Stock Out"}
        </span>

        <IconButton onClick={onClose} size="small">
          <IoClose size={20} />
        </IconButton>
      </DialogTitle>
      <Divider />

      <DialogContent className="px-3 py-0">
        <div className="mb-1">
          <span className="text-darker fw-medium">Available Quantity :</span>
          <span className="fw-medium text-primary">
            {stockData?.availableQty || 10}
          </span>
        </div>

        <div className="mb-3">
          <label className="form-label text-dark">Quantity</label>
          <input type="number" className="form-control" placeholder="e.g. 05" />
        </div>

        <div className="mb-2">
          <label className="form-label text-dark">Description</label>
          <textarea
            name="description"
            className="form-control"
            rows={2}
            placeholder="Enter description"
          />
        </div>
      </DialogContent>

      <DialogActions className="px-3 py-2">
        <Button onClick={onClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            px: 3,
            backgroundColor: "#d32f2f",
            "&:hover": { backgroundColor: "#b71c1c" },
          }}
        >
          {isStockIn ? "Stock In" : "Stock Out"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockInModal;
